import { render } from "./detail_postage.vue?vue&type=template&id=bd4956ba&scoped=true"
import script from "./detail_postage.vue?vue&type=script&lang=js"
export * from "./detail_postage.vue?vue&type=script&lang=js"

import "./detail_postage.vue?vue&type=style&index=0&id=bd4956ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd4956ba"]])

export default __exports__